import { defaultFilters } from './filtersDefinition'
import { defaultGroups } from './groupsDefinition'

export const state = {
  groups: defaultGroups,
  filters: defaultFilters(),
  localPoisTextSearch: '',
  localAdvertsTextSearch: '',
  localShopsTextSearch: '',
  activeGroups: []
}
